/*
 * @Author: shuo.li
 * @Date: 2021-11-3 11:12
 * @LastEditors:
 * @LastEditTime:
 * @Description: 以对象形式获取URL中的查询字符串参数
 * @Input: url:String
 * @Output: Object
 */
export function getQuerystringObj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach(v => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}
